export default function GenerarExternalReference(titular: string | number): string {
  const pad = (n: number) => n.toString().padStart(2, '0');

  const ahora = new Date();

  const fecha =
    ahora.getFullYear().toString() +
    pad(ahora.getMonth() + 1) +
    pad(ahora.getDate()) +
    pad(ahora.getHours()) +
    pad(ahora.getMinutes()) +
    pad(ahora.getSeconds());

  const dni = titular.toString().padStart(10, '0');

  const random = Math.random().toString(16).substring(2, 12).toUpperCase();

  return `SVP-${dni}-${fecha}-${random}`;
};